<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'集成托管服务管理'},{name:'集成托管服务列表'}]" :title="'集成托管服务列表'"/> -->
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">申请结果</span>
                        <el-select v-model="sendInfo.rate" placeholder="请选择" size="small" clearable>
							<el-option
                            v-for="item in status"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                         size="small"
						v-model="sendInfoOne.time"
                         format="yyyy-MM-dd"
						value-format="yyyy-MM-dd HH:mm:ss"
						type="datetimerange"
						:default-time="['24:00:00','23:59:59']"
                         range-separator="至"
                         start-placeholder="开始日期"
                         end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="sendInfoOne.drop" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="sendInfoOne.dropValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button type="primary" size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                @sort-change="sortChange"
                :default-sort="{prop: 'date'}"
                 ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="applyCompany"
                    show-overflow-tooltip
                    width="400"
                    label="公司名称">
                    <template slot-scope="scope">
                        <div class="tableName" @click="viewDetails(scope.row)">{{scope.row.applyCompany}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="applicant"
                    show-overflow-tooltip
                    label="申请人姓名">
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    show-overflow-tooltip
                    label="联系手机号">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="checkStatusValue"
                    show-overflow-tooltip
                    label="申请结果">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                :PageData="PageData"
                v-if="tableData.length>0"
                @nextpage="nextpage"
                @previouspage="previouspage"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                ></Paging>
            </div>
        </div>
    </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			status:[{name:'全部',value: void 0},{name:'处理中',value:0},{name:'申请成功',value:1},{name:'申请失败',value:-1}],//上下架
            options: [{
                value: '1',
                label: '申请ID'
                }, {
                value: '2',
                label: '公司名称'
            }, {
                value: '3',
                label: '账号'
            }, {
                value: '4',
                label: '姓名'
            }, {
                value: '5',
                label: '申请人姓名'
            }, {
                value: '6',
                label: '联系方式'
            }],//检索下拉
            sendInfoOne:{
                time:"",//日期
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            },//检索提交数据
            tableData:[],//表格数据
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
                applicant: void 0, // 申请人姓名
                checkStatus: void 0, // 申请审核状态 0 待审核，1 审核通过，-1 审核打回
                contactPhone: void 0, // 联系人手机号
				property:void 0,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
                endDate:void 0,//结束时间
				startDate:void 0,//开始时间
                financingName: void 0, // 公司名
                id:void 0,//申请id
                loanId: void 0, // 集成托管ID，根据集成托管ID获取申请列表
                name:void 0,//姓名
                rate: void 0, // 申请结果
                userName: void 0,//账号
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
			statusList:[],
        }
    },
	created() {
		
		this.$axiosz.get('/rpc/sysDict/parentId/1069409909080064').then(res=>{
		    if(res.code==200){
				this.statusList=res.data
		    }else{
		        this.$alert(res.msg)
		    }
		})
		this.getList()
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 30
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      //表格跳转详情
        viewDetails:function(row){
            this.$router.push({path:`/integrateManagement/companyDetail/${row.loanId}`,query:{index:'/integrateManagement',params:{id:row.loanId}}})
        },
      onReset(){
        const param= {
            currentPage:1,//当前页
				pageSize:10,//页条数
                applicant: void 0, // 申请人姓名
                checkStatus: void 0, // 申请审核状态 0 待审核，1 审核通过，-1 审核打回
                contactPhone: void 0, // 联系人手机号
				property:void 0,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
                endDate:void 0,//结束时间
				startDate:void 0,//开始时间
                financingName: void 0, // 公司名
                id:void 0,//申请id
                loanId: void 0, // 集成托管ID，根据集成托管ID获取申请列表
                name:void 0,//姓名
                rate: void 0, // 申请结果
                userName: void 0,//账号
            }
            this.sendInfo = Object.assign(this.sendInfo,param)
        this.sendInfoOne={
                time:"",//日期
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            }
            this.retrieval()
      },
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		getList(){
      this.loading = true
			this.$axiosc.get('/backstage/clusterhosting/all/list',{params:this.sendInfo}).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //查询
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0];
				this.sendInfo.endDate=lookData.time[1];
			}else {
                this.sendInfo.startDate=void 0;
                this.sendInfo.endDate=void 0;
            }
            this.sendInfo.id=void 0;
            this.sendInfo.financingName =  void 0
            this.sendInfo.userName=void 0;
            this.sendInfo.name=void 0;
            this.sendInfo.applicant=void 0;
            this.sendInfo.contactPhone=void 0;
            switch(lookData.drop){
                case '1':
                  this.sendInfo.id=lookData.dropValue;
                break;
                case '2':
                  this.sendInfo.financingName=lookData.dropValue;
                break;
                case '3':
                  this.sendInfo.userName=lookData.dropValue;
                break;
                case '4':
                  this.sendInfo.name=lookData.dropValue;
                break;
                case '5':
                  this.sendInfo.applicant=lookData.dropValue;
                break;
                case '6':
                  this.sendInfo.contactPhone=lookData.dropValue;
                break;
            }
			// 检索值
			this.getList()
		},
        //表格排序
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='ASC';
            }else{
                order='DESC';
            }
            this.sendInfo.property=prop;
            this.sendInfo.direction=order;
            this.getList();
        },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:`/integrateManagement/detail/${row.id}`,query:{index:'/integrateManagement'},params:{id:row.id}})
        },
        //发布 编辑
        edit:function(row){
            if(row){//编辑
                this.$router.push({path:'/integrateManagement/edit',query:{id:row.id,index:'/integrateManagement'}})
            }else{//发布
                this.$router.push({path:'/integrateManagement/add',query:{index:'/integrateManagement'}})
            }
        },
        //表格下架,上架按钮
        soldOut:function(row){
		    let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.put('/backstage/intermediary/shelf/obtained/'+row.id).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getList();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
          this.sendInfo.currentPage = val;
          this.getList()
        },
    },watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>
<style scoped="scoped" lang="scss" >
	.noclick{
		color: #DDDDDD;
		border: 1px solid #ddd;
    cursor:not-allowed;
    &:hover,&:active,&:focus{
      color:#DDDDDD;
      border: 1px solid #ddd;
    }
	}
</style>
